import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 42.52 42.52",
  "content": "<symbol viewBox=\"0 0 42.52 42.52\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-star\"><circle cx=\"21.26\" cy=\"21.26\" fill=\"#e6007e\" r=\"21.26\" /><path d=\"m21.52 29.25 7.89 4.14-1.51-8.78 6.38-6.21-8.82-1.29-3.94-7.98-3.94 7.98-8.81 1.29 6.37 6.21-1.5 8.78z\" fill=\"none\" stroke=\"#fff\" stroke-linejoin=\"round\" stroke-width=\"1.077486\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol